import request from "../utils/request";
import axios from "axios";
/**
 * 表单系统提交
 * @param
 * {
 *   realname: this.phoneNo, 姓名
 *   mobile: this.phoneNo, 手机号
 *   activity_id: 20200828, 活动id 由产品提供
 *   blog_url: getQueryString('utm_source') || '', 从哪里点击来的
 *   googleplus: window.sessionId, 这里诸葛的埋点信息  sid + '&' + did 这样连接而成
 *   extend1: this.phoneNo // 扩展信息 没用的话就传手机号就行
 * }
 * @returns {*}
 */
export function submitFormSys(data) {
  return request({
    // eslint-disable-next-line no-undef
    url: process.env.VUE_APP_BASE_collectUrl + "/usercollect/registV2/",
    method: "POST",
    data: data,
    headers: {},
  });
}

/***
 *  获取验证码
 * @param { phoneNo: this.phoneNo} //参数为手机号
 * @returns {*}
 */
export function getVerificationCode(params) {
  return request({
    // eslint-disable-next-line no-undef
    url:
      process.env.VUE_APP_BASE_onlineUrl +
      "/online/verificationCode/sendPhoneCode",
    method: "get",
    params: params,
  });
}

/**
 * 验证验证码是否正确
 * @param {
 *    userName: this.phoneNo, 用户名 一般是手机号
 *    code: this.code,        输入的验证码
 *    rememberMe : true,      表示是否记住登录状态 默认写个ture 就行
 *    loginTerminal: "pc",    表示端 pc 就写pc 手机就写 h5
 * }
 * @returns {*}
 */
export function registerByCode(data) {
  return request({
    // eslint-disable-next-line no-undef
    url:
      process.env.VUE_APP_BASE_onlineUrl +
      "/online/user/loginAndRegisterByCode",
    method: "POST",
    data: data,
    headers: {},
  });
}

/**
 * 领取课程方法 参数我不记得了 需要和查看后端提供的格式
 * @param data
 * @returns {*}
 */

export function saveOrder(data) {
  return request({
    // eslint-disable-next-line no-undef
    url: process.env.VUE_APP_BASE_onlineUrl + "/web/save",
    method: "POST",
    data: data,
    headers: {
      "Content-type": "application/json;charset=UTF-8",
    },
  });
}

/**
 * 获取优惠券
 * @param {
 *   name: phone 电话号码,
 *   mobile: phone 电话号码,
 *   verificationCode: 验证码,
 *   campaignId: 优惠卷id,
 *   blog_url : 从哪里来的，
 *   field1： // 感觉是扩展字段
 *   field3 : '' 传递的是当钱href
 *
 * }
 * @returns {Promise<unknown>|*}
 */

export function getVertialcode(data) {
  if (!data.campaignId) {
    return new Promise(
      (resolve) => {},
      (reject) => {
        reject("需要优惠卷编码");
      }
    );
  }
  return request({
    // eslint-disable-next-line no-undef
    url:
      process.env.VUE_APP_BASE_mUrl +
      "/api/campaign/" +
      data.campaignId +
      "/form",
    method: "POST",
    data: data,
    crossDomain: true,
    withCredentials: false,
  });
}

/**
 * 检查用户是否领取过优惠卷
 * @param {
 *   mobile 电话号码
 *   couponGroupSerialNo应该是优惠卷的批次号
 * }
 * @returns {*}
 */

export function checkCoupon(data) {
  return request({
    // eslint-disable-next-line no-undef
    url: process.env.VUE_APP_BASE_appBaseUrl + "/bxg/coupon/group/mobile",
    method: "get",
    headers: {
      "Content-type": "application/json;charset=UTF-8",
    },
  });
}
/**
 * 检查活动是否过有效期
 * @param {
 *   activityId 活动id，每次活动都会生成一个固定的活动id，每次都不一样
 * }
 * @returns {*}
 */
export function activityId(data) {
  return request({
    // eslint-disable-next-line no-undef
    url: process.env.VUE_APP_BASE_gatewayUrl + "/activity-api/activity/valid",
    method: "get",
    params: data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

/**
 * 调用微信分享配置
 * @param {
 *   shareLink
 * }
 * @returns {*}
 */

export function wechatConfig(data) {
  return request({
    // eslint-disable-next-line no-undef
    url: process.env.VUE_APP_BASE_appBaseUrl + "/user/share",
    method: "post",
    params: data,
  });
}

/**
 * 获取用户剩余积分
 * @param {
 *   activityId 双十一活动ID
 *   activityType 活动类型（ 0 - 2020双十一活动 ）
 * }
 * @returns {*}
 */

export function getIntegral(data, sign) {
  return request({
    // eslint-disable-next-line no-undef
    url:
      process.env.VUE_APP_BASE_gatewayUrl +
      "/activity-api/points/GET/activityPoints",
    method: "get",
    params: data,
    headers: {
      Authorization: sign,
    },
  });
}

// 获取地址栏参数
export function getQueryString(key) {
  var url = window.location.search;
  var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
  var result = url.substr(1).match(reg);
  return result ? decodeURIComponent(result[2]) : null;
}

// 获取用户信息
export function IsAlive() {
  return request({
    url: process.env.VUE_APP_BASE_onlineUrl + "/online/user/isAlive",
    method: "get",
  });
}

// 根据当前链接获取详情页跳转链接
export function getSkipUrl(params) {
  return request({
    url:
      process.env.VUE_APP_BASE_gatewayUrl +
      "/portal-marketing/course-detail/skip-url",
    method: "get",
    params: params,
    headers: {
      application: "h5",
    },
  });
}

/**
 *  生成验证码拼图
 *  data {
 *  }
 *
 */

export function createCaptcha(data) {
  return axios({
    url: `${process.env.VUE_APP_BASE_gatewayUrl}/portal-study/captcha/createCaptcha`,
    method: "post",
    data: data,
    headers: {
      "Content-type": "application/json;charset=UTF-8",
    },
  });
}
/**
 *  验证码拼图校验
 *
 */

export function validCaptcha(params) {
  return axios({
    url: `${process.env.VUE_APP_BASE_gatewayUrl}/portal-study/captcha/validCaptcha`,
    method: "GET",
    params: params,
  });
}



// 获取省份
export function getAllProvince() {
  return axios({
    url:`${process.env.VUE_APP_BASE_onlineUrl}/online/user/getAllProvince`,
    method: 'get',
  })
}

// 获取城市
export function getCityByProId(params) {
  return axios({
    url: `${process.env.VUE_APP_BASE_onlineUrl}/online/user/getCityByProId`,
    method: 'get',
    params: params
  })
}

// 文件上传
export function uploadFile(data) {
  return axios({
    url: `${process.env.VUE_APP_BASE_appUrl}/bxg/apiAttachment/uploadNoSign`,
    method: 'post',
    data: data,
    headers: { "Content-Type": "multipart/form-data" }
  })
}

// 在校生认证
export function onCampusStudent(data) {
  return axios({
    url: `${process.env.VUE_APP_BASE_gatewayUrl}/portal-marketing/stu-collect-info/on-campus-student/auth`,
    method: 'post',
    data: data,
    headers: { "Content-Type": "	application/json" }
  })
}

/**
 *  分类列表
 *
 */

export function categoryList(params) {
  return axios({
    url: `${process.env.VUE_APP_BASE_gatewayUrl}/portal-marketing/graduation-project/category`,
    method: "GET",
    params: params,
  });
}

/**
 *  分类下商品列表
 *
 */

export function categoryGoods(params) {
  return axios({
    url: `${process.env.VUE_APP_BASE_gatewayUrl}/portal-marketing/graduation-project/category/goods`,
    method: "GET",
    params: params,
  });
}
/**
 *  站外营销域名信息
 *
 */

export function domainInfo() {
  return axios({
    url: `${process.env.VUE_APP_BASE_appUrl}/home/marketing-live/domain-info`,
    method: "GET",
  
  });
}
